export const SWITCH_BUTTON = 'switch-label-button';
